
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from "@mui/material/styles";

const MessageContainer = styled(Container)(() => ({
  height: '100%',
  textAlign: 'center',
}));
const MessageTypography = styled(Typography)(() => ({
  alignContent: 'center',
  height: '100%',
}));

export const NotAuthorized = () => (
  <MessageContainer>
    <MessageTypography variant="h4">
      You are not authorized to view this page
    </MessageTypography>
  </MessageContainer>
);
